import { useContext } from 'react';

import { PaymentContext } from '@/payment/providers/PaymentContext';

export const usePayment = () => useContext(PaymentContext)!!;
